import { updateQnAPreference } from "@/components/app/manage-event/pulse/qna/actions";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Text } from "@/components/ui/text";
import { useEventQnASettings } from "@/hooks/use-qna-query";
import { useModal } from "@/stores/use-modal-store";
import { X } from "lucide-react";
import React, { Fragment, useEffect, useState } from "react";

const QAPrefrenceModal = () => {
  const { isOpen, onClose, data, type } = useModal();

  const eventId = data.eventId || "";

  const { data: qnaData, refetch } = useEventQnASettings({
    eventId: eventId
  });
  const [qnaSettings, setQnaSettings] = useState({
    approveQuestionsForModeration: false,
    allowAnonymousQuestions: false,
    whoCanComment: "hosts"
  });

  const isDialogOpen = isOpen && type === "qaPreference";

  useEffect(() => {
    if (qnaData?.qnaSettings) {
      setQnaSettings({
        approveQuestionsForModeration: qnaData.qnaSettings.approveQuestionsForModeration,
        allowAnonymousQuestions: qnaData.qnaSettings.allowAnonymousQuestions,
        whoCanComment: qnaData.qnaSettings.whoCanComment || "hosts"
      });
    }
  }, [qnaData]);

  const handleSettingChange = async (key: keyof typeof qnaSettings, value: boolean | string) => {
    setQnaSettings((prev) => ({ ...prev, [key]: value }));
    await updateQnAPreference(eventId, { [key]: value });
  };

  const handleToggleQnAStatus = async () => {
    const newStatus = qnaData?.status === "enabled" ? "disabled" : "enabled";
    await updateQnAPreference(eventId, { status: newStatus });
    refetch();
    onClose();
  };

  const COMMENT_OPTIONS = [
    { value: "all", label: "All" },
    { value: "host", label: "Hosts" },
    { value: "featured_guest", label: "Featured guests" }
  ];

  return (
    <>
      <Dialog open={isDialogOpen} onOpenChange={onClose}>
        <DialogContent
          className="max-w-full-50px w-[500px]"
          isShowCloseBtn={false}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between mb-6">
            <DialogTitle>Q&A preferences</DialogTitle>
            <div className="ms-auto " onClick={onClose}>
              <X className="h-4 w-4 cursor-pointer" />
            </div>
          </div>

          <Fragment>
            <div className="flex flex-col gap-[30px]">
              {/* <div className="flex items-center justify-between ">
                <Text variant={"body_two"}>Approve question for moderation</Text>
                <Switch
                  checked={qnaSettings.approveQuestionsForModeration}
                  onCheckedChange={(value) =>
                    handleSettingChange("approveQuestionsForModeration", value)
                  }
                />
              </div> */}
              {qnaData?.status !== "disabled" ? (
                <>
                  <div className="flex items-center justify-between  ">
                    <Text variant={"body_two"}>Allow submitting questions anonymously</Text>
                    <Switch
                      checked={qnaSettings.allowAnonymousQuestions}
                      onCheckedChange={(value) =>
                        handleSettingChange("allowAnonymousQuestions", value)
                      }
                    />
                  </div>
                  <div className="flex justify-between items-center">
                    <Text variant={"body_two"}>Who can comment</Text>

                    <Select
                      value={qnaSettings.whoCanComment}
                      onValueChange={(value) => handleSettingChange("whoCanComment", value)}
                    >
                      <SelectTrigger className="!h-[30px] font-medium ms-auto !px-m !py-xs rounded-8 text-body1 pe-2">
                        <SelectValue placeholder="Select permission">
                          {COMMENT_OPTIONS.find(
                            (option) => option.value === qnaSettings.whoCanComment
                          )?.label || "Select permission"}
                        </SelectValue>
                      </SelectTrigger>
                      <SelectContent>
                        {COMMENT_OPTIONS.map(({ value, label }) => (
                          <SelectItem key={value} value={value} className="border-b-1">
                            {label}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="flex flex-col gap-[10px]">
                <div className="flex items-center justify-between  ">
                  <Text variant={"body_two"}>Enable Q&A</Text>
                  <Switch
                    checked={qnaData?.status === "enabled" ? true : false}
                    onCheckedChange={(value) => {
                      handleToggleQnAStatus();
                    }}
                  />
                </div>
                <Text variant={"body_one"} className="text-[#707070]">
                  When Q&A is disabled, attendees will lose the ability to ask and upvote questions
                </Text>
              </div>
              {/* <div className=" flex w-full justify-end">
                <Button className="w-[180px]" type="button" onClick={handleToggleQnAStatus}>
                  {qnaData?.status === "enabled" ? "Disabled Q&A" : "Enabled Q&A"}
                </Button>
              </div> */}
            </div>
          </Fragment>
          {/* )} */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default QAPrefrenceModal;
